export const documentStatus = {
  preserved: 'Preservado',
  registered: 'Registrado',
  revoked: 'Revogado',
  canceled: 'Cancelado',
  validated: 'Validado',
  preserving: 'Preservando',
  registering: 'Registrando',
  sendingToPreservation: 'Enviando para preservação',
  sentToPreservation: 'Enviado para preservação',
  receivedFromPreservation: 'Recebido da preservação',
  preservationFail: 'Falha na preservação',
  sendingToRegistry: 'Enviando para registro',
  sentToRegistry: 'Enviado para registro',
  receivedFromRegistry: 'Recebido do registro',
  registerFail: 'Falha no registro',
};
